import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../../../config.json";
import Items from "../AppsMenu/Shop/Items/Items";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import "./kitchenLuxe.css";

const ItemsGrid = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchItems = async () => {
    try {
      const response = await axios.get(`${config.dev}/v2/items/retrieve`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      });
      const data = response?.data || [];
      setItems(data);
      setFilteredItems(data);
      setIsError(false);
    } catch (err) {
      setError("Failed to fetch items. Please try again later.");
      setIsError(true);
      console.error("Error fetching items:", err);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  useEffect(() => {
    const results = items.filter((item) => {
      const matchesDetails = item.itemDetails
        ? item.itemDetails.some((detail) =>
            ["itemTitle"].some((key) =>
              detail[key]?.toLowerCase().includes(searchTerm.toLowerCase())
            )
          )
        : false;

      return matchesDetails;
    });

    setFilteredItems(results);
  }, [searchTerm, items]);

  return (
    <Fragment>
      <div className="kitchen-page" data-tour="tour-page-items">
        <PageTitle activeMenu={t("items")} motherMenu={t("kitchen")} />
        <div className="kitchen-toolbar">
          <div className="kitchen-toolbar__search">
            <input
              type="text"
              className="form-control"
              placeholder={t("searchByTitle")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="kitchen-toolbar__actions">
            <Link to={"/add-item"} className="kitchen-toolbar__add">
              <i className="fas fa-plus" />
              {t("addNewItem")}
            </Link>
          </div>
        </div>
        <div className="row kitchen-grid">
          {filteredItems.length === 0 ? (
            <div className="col-12">
              <div className="kitchen-empty" role="alert">
                {isError ? error : t("noDataFound")}
              </div>
            </div>
          ) : (
            filteredItems.map((item) => (
              <Items key={item._id} fetchItems={fetchItems} item={item} />
            ))
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ItemsGrid;
